import React, { useState } from 'react';
import Header from './Header';
import Hero from './Hero';
import BrandManifesto from './BrandManifesto';
import Manifesto from './Manifesto';
import ShopCollections from './ShopCollections';
import MediaSection from './MediaSection';
import OurStory from './OurStory';
import MailingList from './MailingList';
import Footer from './Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-warmCream">
      <Header />
      <Hero />
      <BrandManifesto />
      <Manifesto />
      <ShopCollections />
      <MediaSection />
      <OurStory />
      <MailingList />
      <Footer />
    </div>
  );
};

export default HomePage;